// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1jpXd","large":"styles_large__3Pcw8"};